// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"46dd4715","734":"bd4c70c7","737":"1357b59f","918":"8db111aa"}[chunkId] + ".chunk.js";
};